import type { UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'
export const baseUrl = import.meta.env.VITE_BASE_URL

export * from './useEnums'

export type QueryOptions = Omit<UseQueryOptions<AxiosResponse<any, any>, any, AxiosResponse<any, any>, any>, 'queryKey' | 'queryFn'> | undefined
export type GenericQueryOptions<T> = Omit<UseQueryOptions<AxiosResponse<T, any>, any, AxiosResponse<T, any>, any>, 'queryKey' | 'queryFn'> | undefined & {
    enabled?: boolean
    gcTime?: number

    staleTime?: number

    retry?: UseQueryOptions['retry']
    refetchOnWindowFocus?: boolean
    refetchOnMount?: boolean

    refetchInterval?: number
}

export type MutationOptions = Omit<UseMutationOptions<AxiosResponse<any, any>, any, any, any>, 'mutationKey' | 'mutationFn'> | undefined
export type GenericMutationOptions<T> = Omit<UseMutationOptions<AxiosResponse<T, any>, any, any, any>, 'mutationKey' | 'mutationFn'> | undefined

export function appendToFormData(formData: FormData, data: any, parentKey?: string) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        const isArray = Array.isArray(data)
        Object.keys(data).forEach(key => {
            // Array indexy → [i], property objektu → .key (kvůli ASP.NET model bindingu komplexních typů)
            const fullKey = !parentKey
                ? key
                : isArray
                    ? `${parentKey}[${key}]`
                    : `${parentKey}.${key}`
            appendToFormData(formData, data[key], fullKey)
        })
    } else {
        if (parentKey) {
            if (data === undefined)
                return

            // Pro primitivní typy nebo instance Date/File přidá hodnotu do FormData.
            if (data instanceof Date)
                formData.append(parentKey, data.toISOString())
            else
                formData.append(parentKey, data)
        }
    }
}

export * from './offerFilter'
export * from './useAccount'
export * from './useExport'
export * from './useInsuranceParamsFormPersistance'
export * from './useMeetingRecord'
export * from './useNavigateLogger'
export * from './usePerson'
export * from './useResetPassword'
export * from './useReturnUrlNavigate'
export * from './useSearchParamsStatePersistance'
export * from './useSso'
export * from './useTimeRange'

